import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-lab-biohemija-cat',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './lab-biohemija-cat.component.html',
  styleUrls: ['./lab-biohemija-cat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabBiohemijaCatComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  constructor() {
    super();
    this.form = this.fb.group({
      totalProteins: new FormControl(''),
      urea: new FormControl(''),
      creatinine: new FormControl(''),
      glucose: new FormControl(''),
      alt: new FormControl(''),
      alp: new FormControl(''),
      veterinarianName: new FormControl(''),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );
  }
}
